import styled from "styled-components";
import theme from "../../../styles/theme";
import { IconButton } from "@mui/material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  width: 100vw;
  overflow-y: auto;
  /* height: 100vh; */
`;
export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-top: 4vh;
  align-items: center;
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;
export const LogoImg = styled.img`
  height: 3vh;
  margin-left: 7vw;
  @media ${theme.devices.tablet} {
    margin-left: 0vw;
  }
`;

export const TopTitle = styled.span`
  color: #5f6368;
  font-family: "Roboto", sans-serif;
  font-size: ${theme.fontSize.xxlg};
  text-align-last: center;
  margin-top: 5vh;
  font-weight: 800;
  @media ${theme.devices.tablet} {
    margin-top: 0vh;
    font-size: ${theme.fontSize.lg};
  }
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 2vw;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    row-gap: 2vh;
  }
`;
export const StyledFilterButton = styled(IconButton)`
  background-color: ${theme.colors.blue.primary} !important;
  color: white !important;
  width: 48px;
  height: 48px;
  transition: background-color 0.3s ease;
  margin-top: auto !important;
  margin-bottom: 0.5vh !important;

  &:hover {
    background-color: #3367d6 !important; // Um tom mais escuro de azul para o hover
  }
`;
export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  margin-top: 4vh;
  .chart-container {
    margin-top: 3vh;
    height: 80%;
    justify-items: center;
    @media ${theme.devices.tablet} {
      height: 100%;
    }
  }
  @media ${theme.devices.tablet} {
    width: 80%;
  }
`;

export const InfoData = styled.div`
  display: flex;
  width: fit-content;
  flex-direction: column;
  color: #5f6368;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-top: 4vh;
  margin-bottom: 4vh;
  padding-inline: 4vw;
  align-self: center;
  hr {
    color: #e7e8e9;
    width: 100%;
  }
  .line-data {
    font-family: "Roboto", sans-serif;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 1vh;
    font-size: ${theme.fontSize.md};
    @media ${theme.devices.tablet} {
      font-size: ${theme.fontSize.mm};
    }
    .stronger {
      font-weight: 800;
      color: black;
    }
  }
`;
